module.exports = __webpack_public_path__ + "static/media/list21.831bb04e.png";